import { useState, useEffect } from 'react';
import utility from 'src/utils/utility';

export const useDetectWrap = (className: string, initialHeight: number) => {
    const [onResizeWrapped, setOnResizeWrapped] = useState(false)

    useEffect(() => {
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    function handleResize() {        
        const hasWrapped = utility.detectWrap(className, initialHeight)
        setOnResizeWrapped(hasWrapped)
    }

    return onResizeWrapped;
};